import { getDefaultConfig } from '../base.js';

const envConfig = {
    subDomain: 'certification',
    rootDomain: 'mohegansun.cert.fndl.dev',
    apis: {
        CppClient: {
            baseUrl: 'https://usw2-promoapi.fanduel.mohegansuncasino.mohegansun.cert.fndl.dev'
        }
    },
    services: {
        braze: {
            key: '5521ecb5-0815-4eb7-86da-ca32fda533ce',
            product: 'FD-CASINO'
        },
        smartBanner: {
            id: 1576195494
        }
    }
};

export const config = getDefaultConfig(envConfig);
